import { AuthContext } from '@/store';
import { useNodeProps } from '@/node-editor/hooks';
import { INode, INodeProps } from '@/types/node';
import { Box, Button, Icon, Theme, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { IContent } from './contract';
import { browser } from '@/lib/utils/detect';
import { useTheme } from '@mui/material/styles';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

interface IContainerStyleProps {
  override: Record<string, any>;
}

const useContainerStyles = (
  theme: Theme,
  { override }: IContainerStyleProps
) => ({
  root: {
    textAlign: 'center !important',
    ...override.root,
  },
  icon: {
    verticalAlign: 'middle !important',
  },
  instruction: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    borderRadius: '5px !important',
    padding: `${theme.spacing(1)}px !important`,
    marginTop: `${theme.spacing(1)}px !important`,
    marginBottom: `${theme.spacing(1)}px !important`,
  },
  note: {
    fontSize: '0.7rem !important',
  },
});

export const Render = ({
  node: {
    id,
    override,
    content: { description },
  },
  conferenceId,
}: IProps) => {
  const theme = useTheme();
  const classes = useContainerStyles(theme, { override });
  const { authState } = useContext(AuthContext);
  const insideIframe = window.self !== window.top; // Page editor
  const isIOS = browser.isIOS;
  const isTouch = browser.isTouchScreen;
  const isPWA = (window as any).INSIDE_PWA;

  const [showInfo, setShowInfo] = useState(false);

  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      {(insideIframe || (isTouch && !isPWA && authState.userLoggedIn)) && (
        <>
          {!showInfo ? (
            <Button
              startIcon={<Icon>add_box</Icon>}
              variant="contained"
              color="primary"
              onClick={() => setShowInfo(true)}
            >
              {window.LANG.WEBAPP_BTN}
            </Button>
          ) : (
            <Box sx={classes.instruction}>
              {isIOS ? (
                <div style={{ padding: '8px' }}>
                  <Icon sx={classes.icon}>ios_share</Icon>{' '}
                  {window.LANG.WEBAPP_IOS}
                </div>
              ) : (
                <div style={{ padding: '8px' }}>
                  <Icon sx={classes.icon}>more_vert</Icon>{' '}
                  {window.LANG.WEBAPP_ANDROID}
                </div>
              )}
            </Box>
          )}
          {description && (
            <Box mt={1} sx={classes.note}>
              <Typography>{description}</Typography>
            </Box>
          )}

          {insideIframe && (
            <Box mt={1} sx={classes.note}>
              <Typography color="error">
                This button only show in mobile, when logged in and not added to
                homescreen.
              </Typography>
              {!(window as any).SETTINGS.WEB_APP && (
                <Typography color="error">
                  Alert: You need enable web app in conference settings!
                </Typography>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
